import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './context/UserContext';

import Login from './components/Login';
import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import Dashboard from './components/Dashboard';
import VerifyEmail from './components/VerifyEmail';



import ImportFileExcel from './components/dashboardContent/ImportFileExcel';
import PageLayout from './components/dashboardContent/PageLayout';
import PageLayout2 from './components/dashboardContent/PageLayout2';
import AllFichesTechniques from './components/dashboardContent/AllFichesTechniques';
import FicheTechnique from './components/dashboardContent/FicheTechnique';
import PageLayoutVersion2 from './components/dashboardContentV2/PageLayout';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const authStatus = localStorage.getItem('isAuthenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleAuth = (status) => {
    setIsAuthenticated(status);
    localStorage.setItem('isAuthenticated', status);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('isAuthenticated');
  };

  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Routes accessibles sans authentification */}
          {!isAuthenticated ? (
            <>
              <Route path="/login" element={<Login setAuth={handleAuth} />} />
              <Route path="/register" element={<Register setAuth={handleAuth} />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verify-email" element={<VerifyEmail />} />
              <Route path="*" element={<Navigate to="/login" />} />
            </>
          ) : (
            <>
              <Route path="/" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/AllFichesTechniques" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/FicheTechnique" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/form" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ChangePassword" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/Report" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ImportFileExcel" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/OriginalInstitution" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/StudentSelector" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ContactUs" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/EtablissementAccueil" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/LeSeuil" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/InputNotes" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DeuxiemeLangueSelonDepartement" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/RepartitionDesElevesOrientes" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/EtudiantsInterieurVille" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DistributionStudentsOutsideCity" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/MinutesOfDepartmentCouncilDecision" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/MinutesOfDepartmentCouncilDecision1" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ResultatsDesConseils" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ListeEtudiantsExclus" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/GradeScale" element={<Dashboard handleLogout={handleLogout} />} />
              
                    {/*  ------------------------------------------------------  */}

              <Route path="/PageLayoutVersion2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayoutActionsV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ImportFileExcelV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/OriginalInstitutionV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/StudentSelectorV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout2V2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/EtablissementAccueilV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/LeSeuilV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/InputNotesV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DeuxiemeLangueSelonDepartementV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DecisionConseilSelonDepartementV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout3V2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/RepartitionDesElevesOrientesV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/EtudiantsInterieurVilleV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DistributionStudentsOutsideCityV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/MinutesOfDepartmentCouncilDecisionV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/MinutesOfDepartmentCouncilDecision1V2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ResultatsDesConseilsV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ListeEtudiantsExclusV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/GradeScaleV2" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/TableAV2" element={<Dashboard handleLogout={handleLogout} />} />

                                 {/*  ------------------------------------------------------  */}

              <Route path="/PageLayoutVersion3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ImportFileExcelV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/OriginalInstitutionV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/StudentSelectorV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout2V3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/EtablissementAccueilV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/LeSeuilV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/InputNotesV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DeuxiemeLangueSelonDepartementV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/PageLayout3V3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/RepartitionDesElevesOrientesV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/EtudiantsInterieurVilleV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/DistributionStudentsOutsideCityV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/MinutesOfDepartmentCouncilDecisionV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/MinutesOfDepartmentCouncilDecision1V3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ResultatsDesConseilsV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/ListeEtudiantsExclusV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/GradeScaleV3" element={<Dashboard handleLogout={handleLogout} />} />
              <Route path="/TableAV3" element={<Dashboard handleLogout={handleLogout} />} />


{/*               <Route path="/PageLayoutVersion2" element={<PageLayoutVersion2 />} />
 */}
              
              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </Router>
    </UserProvider>
  );
};

export default App;
